import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasRinconVictoria() {
  return (
    <CityPagePersianas
      name="Rincón de la Victoria"
      slug="rincon-de-la-victoria"
      cp="29730"
      poblacion={50000}
      zonaGeo="Costa del Sol Oriental"
      lat={36.7152}
      lng={-4.2840}
      zonas={[
        "Rincón Centro",
        "Torre de Benagalbón",
        "La Cala del Moral",
        "Añoreta",
      ]}
      landmarks={[
        "Cueva del Tesoro",
        "Paseo Marítimo",
        "Castillo del Bizcocho",
        "Añoreta Golf",
      ]}
      municipiosLimitrofes={[
        "Málaga",
        "Vélez-Málaga",
        "Macharaviaya",
      ]}
      festivalLocal="Feria de Rincón, mediados de julio"
      contextoTipologico="Zona residencial en expansión cercana a Málaga, edificios costeros, comunidades de vecinos extensas."
      isCoreZone={false}
    />
  );
}